import { Input } from "@chakra-ui/react";
import moment from "moment";
import React, { memo, useMemo } from "react";

type DateInputProps = {
  value?: Date;
  onChange: (date?: Date) => void;
};

const DateInput = ({ value, onChange }: DateInputProps) => {
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(moment(event.target.value).toDate());
  };

  const valueAsString = useMemo(() => {
    // try/catch allows user to backspace to change the date
    try {
      return value?.toISOString().substring(0, 10) || "";
    } catch {
      return "";
    }
  }, [value]);

  return (
    <Input
      type="date"
      size="sm"
      value={valueAsString}
      onChange={handleDateChange}
    />
  );
};

export default memo(DateInput);
